import { format, max } from '@/utils/dates';

type GetFormattedLatestDateParams = {
  dateOne: string;
  dateTwo: string;
};

export const getFormattedLatestDate = ({ dateOne, dateTwo }: GetFormattedLatestDateParams) => {
  return format(max([dateOne, dateTwo]), 'yyyy-MM-dd');
};
